import axios from "axios";
import {baseUrlCatalog, xApiKeyCatalog} from "../../config/api/apiConfig";

const companyCode = 'amarta';

class CatalogAreaServices {
    private axios = axios.create({
        baseURL: baseUrlCatalog,
    });

    public async getCatalogArea() {
        const queries = {
            show_active_unactive: true
        }

        try {
            return await this.axios.get<any>(`/area/${companyCode}/area`, {
                headers: {
                    "X-Api-Key": xApiKeyCatalog,
                },
                params: {
                    ...queries,
                }
            });
        } catch (e: any) {
            throw new Error(e);
        }
    }

    public async getCatalogCityGroup(params?: { area?: string, company?: string }) {
        const queries = {
            show_active_unactive: true,
            ...(params?.area && {
                area: params.area,
            })
        }

        try {
            return await this.axios.get<any>(`/area/${params?.company}/city_group`, {
                headers: {
                    "X-Api-Key": xApiKeyCatalog,
                },
                params: {
                    ...queries,
                }
            });
        } catch (e: any) {
            throw new Error(e);
        }
    }

    public async getCatalogCity(params?: { area?: string }) {
        const queries = {
            show_active_unactive: true,
            ...(params?.area && {
                area: params.area,
            })
        }

        try {
            return await this.axios.get<any>(`/area/${companyCode}/city`, {
                headers: {
                    "X-Api-Key": xApiKeyCatalog,
                },
                params: {
                    ...queries,
                }
            });
        } catch (e: any) {
            throw new Error(e);
        }
    }

    public async getCatalogVariant(params?: { companyCode?: string, areaCode?: string, modelName?: string, variantCode?: string, homeShowed?: boolean }) {
        const finalCompanyCode = params?.companyCode ? params?.companyCode : companyCode;

        const queries = {
            ...(params?.modelName && {
                model_name: params.modelName,
            }),
            ...(params?.variantCode && {
                code: params.variantCode,
            }),
            ...(params?.homeShowed && {
                home_showed: params.homeShowed,
            }),
        }
        try {
            return await this.axios.get<any>(`products/${finalCompanyCode}/citygroup/` + params?.areaCode?.toLowerCase() + '/variant', {
                headers: {
                    "X-Api-Key": xApiKeyCatalog,
                },
                params: {
                    ...queries,
                }
            });
        } catch (e: any) {
            throw new Error(e);
        }
    }

}

export const catalogAreaServices = new CatalogAreaServices();
